import { isStringEmptyOrNull } from "../../../../utils/common";
import moment from 'moment';
import { MSG_EMPTY_REQUIRED, MSG_GREATER_ENDDATE, MSG_EXCEEDS_CHARACTER, MSG_LESSER_ENDTIME } from "../../../../utils/messages";
import { TIME_FORMAT, DATE_FORMAT } from '../../../../utils/constants'

export const validateBannerForm = (values) => {
    let errors = {};
    let data = values.BannerModel;

    if (isStringEmptyOrNull(data.title)) {
        errors[`BannerModel.title`] = MSG_EMPTY_REQUIRED;
    } else if(150 < data.title.length){
        errors[`BannerModel.title`] = MSG_EXCEEDS_CHARACTER;
    } 

    if (isStringEmptyOrNull(data.message) || "<p></p>\n".toString() === data.message.toString()) {
        errors[`BannerModel.message`] = MSG_EMPTY_REQUIRED
    } else if(2500 < data.message.length){
        errors[`BannerModel.message`] = MSG_EXCEEDS_CHARACTER;
    }

    if (moment(data.endDate).isBefore(moment(data.startDate))) {
        errors[`BannerModel.endDate`] = MSG_GREATER_ENDDATE;
    }

    if (isStringEmptyOrNull(data.announcementTitle)) {
        errors[`BannerModel.announcementTitle`] = MSG_EMPTY_REQUIRED;
    } else if(150 < data.announcementTitle.length){
        errors[`BannerModel.announcementTitle`] = MSG_EXCEEDS_CHARACTER;
    } 

    if (isStringEmptyOrNull(data.announcementMessage) || "<p></p>\n".toString() === data.announcementMessage.toString()) {
        errors[`BannerModel.announcementMessage`] = MSG_EMPTY_REQUIRED
    } else if(2500 < data.announcementMessage.length){
        errors[`BannerModel.announcementMessage`] = MSG_EXCEEDS_CHARACTER;
    }

    
    return errors;
    
}

export const validatePopupForm = (values) => {
    let errors = {};
    let data = values.PopupModel;


    if (isStringEmptyOrNull(data.title)) {
        errors[`PopupModel.title`] = MSG_EMPTY_REQUIRED;
    } else if(150 < data.title.length){
        errors[`PopupModel.title`] = MSG_EXCEEDS_CHARACTER;
    } 

    if (isStringEmptyOrNull(data.message) || "<p></p>\n".toString() === data.message.toString()) {
        errors[`PopupModel.message`] = MSG_EMPTY_REQUIRED
    } else if(2500 < data.message.length){
        errors[`PopupModel.message`] = MSG_EXCEEDS_CHARACTER;
    }

    if (moment(moment(data.endDate).format(TIME_FORMAT), 'HH:mm a').isBefore(moment(moment(data.startDate).format(TIME_FORMAT), 'HH:mm a'))) {
        errors[`PopupModel.endDate`] = MSG_LESSER_ENDTIME;
    }

    if (moment(moment(data.endDate).format(DATE_FORMAT), 'MM/DD/YYYY').isBefore(moment(moment(data.startDate).format(DATE_FORMAT), 'MM/DD/YYYY'))) {
        errors[`PopupModel.endDate`] = MSG_GREATER_ENDDATE;
    }
    return errors;
    
}